import { StyledYoutubeIframe as YoutubeIframe } from '../../../components/YoutubeIframe.jsx';

export const mapYoutubePlaceholderToYoutubeComponent = matchedElem => {
  const videoUrl = matchedElem.querySelector('iframe').dataset.src;

  return (
    <YoutubeIframe videoUrl={videoUrl} />
  );
};
